//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import {
  YouTubeAudienceSubscriberMetrics,
  YouTubeEngagementMetrics,
} from '@apis/youtube/youtubeApiModel';
import { SCHEDULE_ITEM_TASK_NAME } from '@instagram-account/redux/account/instagramAccountModel';

export const YOUTUBE_SCHEDULE_ITEM_TASK_NAME = SCHEDULE_ITEM_TASK_NAME;
export const ABBREVIATE_NUMERIC_METRICS_LIMIT = 1000000;

export const YouTubeEmptyAudienceMetrics: YouTubeAudienceSubscriberMetrics = {
  changeInSubscribers: 0,
  subscriberCount: 0,
  subscribersGained: 0,
  subscribersLost: 0,
} as const;

export const YouTubeEmptyEngagementMetrics: YouTubeEngagementMetrics = {
  comments: 0,
  dislikes: 0,
  engagementRate: 0,
  likes: 0,
  shares: 0,
  views: 0,
} as const;

export const YouTubeStatBubbleTitles = {
  changeInSubscribers: 'Change in Subscribers',
  comments: 'Comments',
  dislikes: 'Dislikes',
  engagementRate: 'Engagement Rate',
  likes: 'Likes',
  shares: 'Shares',
  views: 'Views',
} as const;

export const YouTubeStatBubbleDefinitionBase = {
  changeInSubscribers: 'Net increase or decrease in subscribers',
  comments: 'Number of comments received',
  dislikes: 'Number of dislikes received',
  engagementRate:
    'Likes and comments your videos have received, divided by their views',
  likes: 'Number of likes received',
  shares: 'Number of times your videos have been shared',
  views: 'Number of views',
} as const;
